import { gql } from '@apollo/client';

export const GET_MANUAL_IMPORT_LOG_ERROR = gql(/* GraphQL */ `
    query GetManualImportLogError($id: String!) {
        getManualImportLogById(id: $id) {
            id
            error
        }
    }
`);
